export default __webpack_public_path__ + "static/media/jasperactive-ac.def25688.svg";